import * as React from 'react';
import { connect } from 'react-redux';

import AgencyOverview from '../components/AgencyOverview';
import BaseAgencyPage from './BaseAgencyPage';

import { t } from 'utils/language';

import type { BrandProfile, Params } from 'types';

type OwnProps = {
  params: Params
};

type StateProps = {
  profile: BrandProfile
};

type Props = OwnProps & StateProps;

const AgencyOverviewPage = ({
  profile,
  params
}: Props) => (
  <BaseAgencyPage
    id={Number(params.id)}
    documentTitle={`${t('agency_profile_title', { agency: profile.name })}`}
    renderChildren={(agencyBrandProfileId) => (
      <AgencyOverview
        key={agencyBrandProfileId}
        agencyProfileId={Number(params.id)}
        agencyBrandProfileId={Number(agencyBrandProfileId)}
      />
    )}
  />
);

const mapStateToProps = ({ brandProfile }): StateProps => ({
  profile: brandProfile.profile
});

export default connect(mapStateToProps)(AgencyOverviewPage);
